/**
 * sling-offer-selector.js — Handles the "Buy 2, get 1 FREE" offer selector
 * on the Sling Bag PDP. Manages offer card toggling, multi-bag color picker
 * with accordion swatches, and add-to-cart for the multi-bag bundle.
 *
 * The main product color swatches (existing variant picker) stay visible in
 * both modes. In multi-bag mode, clicking a main swatch sets ALL bags to
 * that color. Individual bag swatches override only that specific bag.
 */
(function () {
  'use strict';

  var container = document.getElementById('SlingOfferSelector');
  if (!container) return;

  var dataEl = document.getElementById('SlingOfferData');
  if (!dataEl) return;
  var data = JSON.parse(dataEl.textContent);

  var variants = data.variants;
  var unitPrice = data.unitPrice;
  var defaultVariantId = data.defaultVariantId;
  var dealQty = data.dealQty || 3;
  var paidQty = data.paidQty || 2;

  // Build lookups
  var variantMap = {};
  var colorToVariant = {};
  variants.forEach(function (v) {
    variantMap[v.id] = v;
    if (!colorToVariant[v.option1]) {
      colorToVariant[v.option1] = v;
    }
  });

  // ── State ──
  var offerType = dealQty;
  var bagVariantIds = [];
  for (var i = 0; i < dealQty; i++) {
    bagVariantIds.push(defaultVariantId);
  }

  // ── DOM refs ──
  var multiPicker = document.getElementById('SlingMultiPicker');
  var ctaWrap = document.getElementById('SlingOfferCTA');
  var ctaButton = document.getElementById('SlingOfferButton');
  var ctaLabel = ctaButton.querySelector('.sling-offer-cta__label');
  var ctaPrice = ctaButton.querySelector('.sling-offer-cta__price');
  var offerCards = container.querySelectorAll('.sling-offer-card');
  var bagRows = container.querySelectorAll('.sling-bag-row');

  // Section-level ref for event delegation (stable across re-renders)
  var section = container.closest('.main-product-section') || document;
  var existingBuyButtons = section.querySelector('.block-product__buttons');

  // ── Helpers ──

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateOfferCards() {
    offerCards.forEach(function (card) {
      var val = parseInt(card.getAttribute('data-offer'), 10);
      var radio = card.querySelector('.sling-offer-card__radio');
      if (val === offerType) {
        card.classList.add('sling-offer-card--active');
        radio.classList.add('sling-offer-card__radio--checked');
      } else {
        card.classList.remove('sling-offer-card--active');
        radio.classList.remove('sling-offer-card__radio--checked');
      }
    });
  }

  function updateVisibility() {
    if (offerType === dealQty) {
      multiPicker.style.display = '';
      ctaWrap.style.display = '';
      if (existingBuyButtons) existingBuyButtons.classList.add('sling-hide-block');
    } else {
      multiPicker.style.display = 'none';
      ctaWrap.style.display = 'none';
      if (existingBuyButtons) existingBuyButtons.classList.remove('sling-hide-block');
    }
  }

  function updateBagRows() {
    bagRows.forEach(function (row, index) {
      var vid = bagVariantIds[index];
      var variant = variantMap[vid];
      if (!variant) return;

      var thumb = row.querySelector('.sling-bag-row__thumb img');
      var colorLabel = row.querySelector('.sling-bag-row__color');

      if (thumb && variant.image) {
        thumb.src = variant.image;
        thumb.alt = variant.option1;
      }
      if (colorLabel) {
        colorLabel.textContent = variant.option1;
      }

      // Update active swatch in this bag's panel
      row.querySelectorAll('.sling-swatch').forEach(function (s) {
        var sid = parseInt(s.getAttribute('data-variant-id'), 10);
        if (sid === vid) {
          s.classList.add('sling-swatch--active');
        } else {
          s.classList.remove('sling-swatch--active');
        }
      });
    });
  }

  function closeAllSwatchPanels() {
    bagRows.forEach(function (row) {
      row.querySelector('.sling-bag-row__swatches').style.display = 'none';
      row.querySelector('.sling-bag-row__change').textContent = 'Change color';
    });
  }

  function updateCTA() {
    ctaPrice.textContent = formatMoney(unitPrice * paidQty);
  }

  function render() {
    updateOfferCards();
    updateVisibility();
    updateBagRows();
    updateCTA();
  }

  // ── Offer card selection ──
  offerCards.forEach(function (card) {
    card.addEventListener('click', function () {
      offerType = parseInt(card.getAttribute('data-offer'), 10);
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      closeAllSwatchPanels();
      render();
    });
  });

  // ── Main swatch sync (event delegation) ──
  section.addEventListener('change', function (e) {
    if (offerType !== dealQty) return;

    var target = e.target;
    if (!target || target.type !== 'radio') return;
    if (!target.closest('.block-product__variant-picker')) return;

    var colorValue = target.getAttribute('data-option-value');
    if (!colorValue) return;

    var matchingVariant = colorToVariant[colorValue];
    if (!matchingVariant) return;

    // Set all bags to this color
    for (var i = 0; i < dealQty; i++) {
      bagVariantIds[i] = matchingVariant.id;
    }
    closeAllSwatchPanels();
    updateBagRows();
  });

  // ── Individual bag color accordion + swatch clicks ──
  bagRows.forEach(function (row, index) {
    var changeBtn = row.querySelector('.sling-bag-row__change');
    var swatchPanel = row.querySelector('.sling-bag-row__swatches');

    changeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = swatchPanel.style.display !== 'none';
      closeAllSwatchPanels();
      if (!isOpen) {
        swatchPanel.style.display = '';
        changeBtn.textContent = 'Close';
      }
    });

    row.querySelectorAll('.sling-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var vid = parseInt(swatch.getAttribute('data-variant-id'), 10);
        bagVariantIds[index] = vid;
        swatchPanel.style.display = 'none';
        changeBtn.textContent = 'Change color';
        updateBagRows();
      });
    });
  });

  // ── CTA add-to-cart ──
  ctaButton.addEventListener('click', function () {
    if (ctaButton.classList.contains('sling-offer-cta--loading')) return;
    ctaButton.classList.add('sling-offer-cta--loading');
    ctaButton.disabled = true;

    var items = bagVariantIds.map(function (vid) {
      return { id: vid, quantity: 1 };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      if (window.CartBenefits && window.CartBenefits.normalize) {
        window.CartBenefits.normalize();
      }

      var sections = ['cart-icon-bubble'];
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        var sid = cartDrawer.getAttribute('data-section-id');
        if (sid) sections.push(sid);
      }

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: {},
          sections: sections,
          sections_url: window.location.pathname
        })
      });
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        if (typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      }
    })
    .catch(function (err) {
      console.error('SlingOfferSelector: add-to-cart error', err);
    })
    .finally(function () {
      ctaButton.classList.remove('sling-offer-cta--loading');
      ctaButton.disabled = false;
    });
  });

  // ── Initialize ──
  render();
})();
